export const PROPERTIES_PER_PAGE = 12;